import angular from "angular";

angular
  .module("ticketco/common/time_slots")
  .service("TimeSlotsModel", TimeSlotsModel);

function TimeSlotsModel($rootScope) {
  var self = this;
  var initialized = false;
  var eventBus = $rootScope.$new(true);
  var allTimeSlots = [];
  var timeSlots = [];
  var capacities = [];
  var allItemTypes = [];
  var selectedItemTypes = [];
  var itemTypesIndex = {};
  var capacitiesIndex = {};
  let indexByAmount = new Map();
  let indexByTime = {
    min: Infinity,
    max: 0,
  };
  var itemTypeMapper;
  var defaultItemTypeMapper = function (slot, capacity, itemType) {
    var selectedAmount = function selectedAmount(val) {
      if (val === undefined) {
        return itemType.$selected_amount;
      }

      if (
        val < itemType.min_items_per_order &&
        itemType.selected_amount() > 0
      ) {
        val = 0;
      }

      if (
        val < itemType.min_items_per_order &&
        itemType.selected_amount() === 0
      ) {
        val = itemType.min_items_per_order;
      }

      itemType.$selected_amount = val;
      if (val > 0) {
        if (!tc.util.findById(itemType.id, selectedItemTypes)) {
          selectedItemTypes = selectedItemTypes.concat(itemType);
        }
        eventBus.$broadcast("item:added", itemType);
      } else {
        selectedItemTypes = selectedItemTypes.filter(function filterer(
          mItemType
        ) {
          return mItemType.id !== itemType.id;
        });
        eventBus.$broadcast("item:removed", itemType);
      }
      eventBus.$broadcast("item-types:changed", selectedItemTypes);
      return itemType.$selected_amount;
    };
    itemType.$selected_amount = 0;
    itemType.selected_amount = selectedAmount;
    return itemType;
  };

  function findCapacity(capacity, slot) {
    var results = slot.capacities.filter(function filterer(slotCapacity) {
      return slotCapacity.name === capacity.name;
    });
    return results[0];
  }

  function addIndexByAmount({ slot, capacity }) {
    let amount = capacity.amount;
    for (let i = amount; i >= 0; i--) {
      if (indexByAmount.has(i)) {
        indexByAmount.get(i).add(slot.id);
      } else {
        indexByAmount.set(i, new Set([slot.id]));
      }
    }
  }

  function addIndexByTime({ slot, capacity }) {
    indexByTime = Object.assign({}, indexByTime, {
      min: Math.min(indexByTime.min, slot.from.split(":")[0]),
      max: Math.max(indexByTime.max, slot.from.split(":")[0]),
    });
  }

  function processCapacity(slot, capacity, capacityIndex) {
    return Object.assign(
      {
        coordinates: slot.id + "-" + capacity.name,
        slotId: slot.id,
        item_types: (capacity.item_types || []).map(function (itemType, index) {
          var oldItemType = tc.util.findById(itemType.id, allItemTypes);
          itemType.coordinates = slot.id + "-" + capacity.name;
          itemType.slotId = slot.id;
          itemType.slotFrom = slot.from;
          itemType.capacityId = capacity.id;
          itemType.capacityName = capacity.name;
          itemType.actual_price = Math.max(0, itemType.actual_price);
          itemType = itemTypeMapper(slot, capacity, itemType);
          if (!oldItemType) {
            allItemTypes.push(itemType);
          } else {
            oldItemType.retail_price = itemType.retail_price;
            oldItemType.actual_price = itemType.actual_price;
          }
          itemTypesIndex[itemType.id] = {
            slotIndex: slot.index,
            capacityIndex: capacityIndex,
            itemTypeIndex: index,
          };
          capacitiesIndex[capacity.id] = itemType.id;

          if (itemType.retail_price !== itemType.actual_price) {
            capacity.discounted = true;
          }
          return oldItemType || itemType;
        }),
        $amount: function () {
          return (
            this.amount -
            R.pipe(
              R.filter(R.propEq("capacityId", this.id)),
              R.pluck("$selected_amount"),
              R.sum
            )(selectedItemTypes)
          );
        },
      },
      capacity
    );
  }

  function processEmptyCapacity(slot, capacity) {
    return Object.assign(
      {
        empty: true,
        coordinates: slot.id + "-" + capacity.name,
        slotId: slot.id,
        item_types: [],
      },
      capacity
    );
  }

  function slotCapacityReducer(slot) {
    return function (acc, cur, index) {
      var capacity = findCapacity(cur, slot);
      return capacity && capacity.item_types.length > 0
        ? acc.concat(processCapacity(slot, capacity, index))
        : acc.concat(processEmptyCapacity(slot, cur));
    };
  }

  function slotMapper(slot, index) {
    var obj = Object.assign(
      {
        index: index,
      },
      slot
    );
    obj.capacities = capacities.reduce(slotCapacityReducer(obj), []);
    return obj;
  }

  const hasInSet = R.curry(function (list, key, obj) {
    if (list == null) return false;
    return list.has(obj[key]);
  });

  const slotSimeFilter = R.curry(function (time, obj) {
    return (
      tc.dateTime.timeToSeconds(obj.from === "00:00" ? "24:00" : obj.from) >=
      tc.dateTime.timeToSeconds(time + ":00")
    );
  });

  function processSlots(slots, filters = {}) {
    let filterRules = [
      R.pipe(
        R.prop("capacities"),
        R.pluck("item_types"),
        R.flatten,
        R.isEmpty,
        R.not
      ),
    ];

    if (filters.amount) {
      filterRules.push(hasInSet(indexByAmount.get(filters.amount), "id"));
    }
    if (filters.time) {
      filterRules.push(slotSimeFilter(filters.time));
    }

    return slots
      .filter(R.allPass(filterRules))
      .sort(function comparator(a, b) {
        // Fix sort order by replacing 00:00 with 24:00
        var from1 = a.from === "00:00" ? "24:00" : a.from;
        var from2 = b.from === "00:00" ? "24:00" : b.from;
        return (
          tc.dateTime.timeToSeconds(from1) - tc.dateTime.timeToSeconds(from2)
        );
      })
      .map(slotMapper);
  }

  function createFilterIndexes(slots) {
    indexByAmount = new Map();
    slots.forEach((slot) => {
      slot.capacities.forEach((capacity) => {
        addIndexByAmount({ slot, capacity });
        addIndexByTime({ slot, capacity });
      });
    });
  }

  self.initialize = function initialize(options) {
    if (!initialized) {
      itemTypeMapper = options.itemTypeMapper || defaultItemTypeMapper;
      capacities = options.capacities;
      createFilterIndexes(options.slots);
      allTimeSlots = options.slots;
      timeSlots = processSlots(options.slots, options.filters);
      initialized = true;
    }
    return self;
  };

  self.replaceSlots = function (slots, filters) {
    allTimeSlots = slots;
    createFilterIndexes(slots);
    timeSlots = processSlots(slots, filters);
    selectedItemTypes = selectedItemTypes.filter(function (itemType) {
      return self.findItemType(itemType.id);
    });
    eventBus.$broadcast("item-types:changed", selectedItemTypes);
    return self;
  };

  self.filterSlots = function (filters) {
    timeSlots = processSlots(allTimeSlots, filters);

    return self;
  };

  self.getTimeSlots = function (fn) {
    fn(timeSlots);
    return self;
  };

  self.getItemTypes = function (fn) {
    fn(allItemTypes);
    return self;
  };

  self.findItemType = function (itemTypeId) {
    var indexes = itemTypesIndex[itemTypeId];
    return timeSlots[indexes.slotIndex].capacities[indexes.capacityIndex]
      .item_types[indexes.itemTypeIndex];
  };

  self.findCapacity = function (capacityId) {
    var itemTypeId = capacitiesIndex[capacityId];
    var indexes = itemTypesIndex[itemTypeId];
    return timeSlots[indexes.slotIndex].capacities[indexes.capacityIndex];
  };

  self.getSelectedItemTypes = function (fn) {
    return eventBus.$on("item-types:changed", fn);
  };

  self.onItemAdded = function (fn) {
    return eventBus.$on("item:added", fn);
  };

  self.onItemRemoved = function (fn) {
    return eventBus.$on("item:removed", fn);
  };

  self.getMaxCapacity = function () {
    return indexByAmount.size - 1;
  };

  self.getMaxSlotTime = function () {
    return indexByTime.max;
  };

  self.getMinSlotTime = function () {
    return indexByTime.min;
  };
}
